module.exports = __webpack_public_path__ + "static/media/emoji-yellow.f28a79da.svg";